<template>
  <div class="achievement-preview">
    <el-form  label-position="left"   :model="form" size="small">
    <el-row>
      <el-col :span="12">
        <el-form-item label-width="20px">
        <el-input v-model="form.contacts_name"  placeholder="请输入用户姓名" @input="handleInput"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item  label-width="20px">
        <el-date-picker
      v-model="dateValue"
      style="width: 100%;"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      @change="handleDateChange">
    </el-date-picker>

      </el-form-item>
    </el-col>
    </el-row>

    </el-form>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="custom-table">
      <el-table-column prop="contacts_name" width="150" label="姓名" align="center" fixed="left"> </el-table-column>
      <el-table-column prop="contacts_org" width="280" label="单位" align="center"> </el-table-column>
      <el-table-column prop="contacts_position" width="200" label="职位" align="center"> </el-table-column>
      <el-table-column prop="contacts_phone" width="200" label="联系电话" align="center"> </el-table-column>
      <el-table-column prop="date" width="200" label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleRow(scope.row,'look')">成果方延伸服务申请详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paginBox">
      <div class="countNumber">
        共{{ total }}条
      </div>
      <div class="rightPagin">
        <el-pagination @size-change="sizePagination" @current-change="currentPagination"
          :page-size="filter.pageSize" background layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 预览弹框 -->
    <CooperativeServicesDialog ref="previewDialog" />
  </div>
</template>

<script>
import CooperativeServicesDialog from '@/views/bgManage/components/cooperativeServicesDialog.vue'

export default {
  name: 'AchievementExtensionServiceList',
  components: {
    CooperativeServicesDialog
  },
  data() {
    return {
      total: 0,
      dateValue:'',
      form: {
        name:'',
        start_date:'',
        end_date:''
      },
      filter: {
        project_contacts_type:2,
        currPage: 1,
        pageSize: 7,
        name:'',
        start_date:'',
        end_date:''
      },
      dictList:[],
      unitList:[],
      individualList:[],
      tableData: [],
      debounceTimer: null
    }
  },
  created() {
    this.getList();

  },
  methods: {

    sizePagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    currentPagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    handleRow(row, type) {
      if (type === 'look') {
        this.$refs.previewDialog.open(row)
      }
    },
    // 输入框防抖处理
    handleInput() {
      // 清除之前的定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      // 设置新的定时器，500ms 后执行搜索
      this.debounceTimer = setTimeout(() => {
        this.handleFilterChange()
      }, 500)
    },
    // 选择框变化时立即搜索
    handleSelectChange() {
      this.handleFilterChange()
    },
    // 日期选择器变化时立即搜索
    handleDateChange() {
      this.handleFilterChange()
    },
    // 统一处理筛选变化
    handleFilterChange() {
      console.log(this.filter);
      this.filter.currPage = 1;
      this.filter.contacts_name = this.form.name;
      this.filter.start_date = this.dateValue ? this.dateValue[0] : '';
      this.filter.end_date = this.dateValue ? this.dateValue[1] : '';

      this.getList();
    },
    getList() {
      this.$API.getProjectContacts(this.filter).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.pageInfo.allRows;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #303133;
}

::v-deep .el-table th.el-table__cell{
  background: #F2F5FB !important;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #595959;
}

.countNumber {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #515A6E;
}
.paginBox {
  display: flex;
  justify-content: end;
  padding: 0 20px 20px 0;
  align-items: center;
  margin-top: 20px;
  width: 100%;
}

::v-deep .el-pagination.is-background .btn-prev {
  background: none;
}

::v-deep .el-pagination .btn-next .el-icon {
  font-size: 18px;
}

::v-deep .el-pagination .btn-prev .el-icon {
  font-size: 18px;
}

::v-deep .btn-next {
  width: 36px;
  height: 36px;
  background-color: #FFFFFF !important;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #E5E5E5;
}

::v-deep .btn-prev {
  width: 36px;
  height: 36px;
  background-color: #FFFFFF !important;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #E5E5E5;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #FFFFFF;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #2F86FF;
  font-weight: 400;
  font-size: 14px;
  color: #2F86FF;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

::v-deep .el-pagination.is-background .el-pager li {
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #B4B4B4;
  background: none;
  width: 36px;
  height: 36px;
  font-weight: 400;
  font-size: 14px;
  color: #313131;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 35px;
}
</style>
